module.exports = __webpack_public_path__ + "img/bg.deaccc02.jpg";